var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoData = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state / illustrations / general",
    clipPath: "url(#clip0_11509_163846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100 130.645C133.935 130.645 161.446 103.077 161.446 68.9514C161.446 34.8256 133.814 7.25781 100 7.25781C66.0659 7.25781 38.5547 34.8256 38.5547 68.9514C38.5547 103.077 66.0659 130.645 100 130.645Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M156.159 28.1069C158.887 28.1069 161.098 25.8863 161.098 23.1472C161.098 20.408 158.887 18.1875 156.159 18.1875C153.43 18.1875 151.219 20.408 151.219 23.1472C151.219 25.8863 153.43 28.1069 156.159 28.1069Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M163.389 8.75857C165.252 8.75857 166.763 7.24211 166.763 5.37147C166.763 3.50083 165.252 1.98438 163.389 1.98438C161.526 1.98438 160.016 3.50083 160.016 5.37147C160.016 7.24211 161.526 8.75857 163.389 8.75857Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.2172 27.9851C43.0804 27.9851 44.5907 26.4687 44.5907 24.598C44.5907 22.7274 43.0804 21.2109 41.2172 21.2109C39.3541 21.2109 37.8438 22.7274 37.8438 24.598C37.8438 26.4687 39.3541 27.9851 41.2172 27.9851Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6166 93.315C24.0767 93.315 26.8817 90.4988 26.8817 87.0247C26.8817 83.5507 24.0767 80.7344 20.6166 80.7344C17.1565 80.7344 14.3516 83.5507 14.3516 87.0247C14.3516 90.4988 17.1565 93.315 20.6166 93.315Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M99.0108 95.7741L96.8759 95.7427C96.4489 95.7364 96.0273 95.3019 96.0591 94.7732C96.0909 94.2445 96.4232 93.7958 96.8502 93.802L98.9851 93.8334C99.4121 93.8397 99.8337 94.2743 99.8019 94.803C99.7437 95.4321 99.4378 95.7804 99.0108 95.7741Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter0_d_11509_163846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3689 39.3327L115.257 92.702C116.122 94.551 115.358 96.7006 113.517 97.5689L61.3174 122.32C59.4765 123.188 57.3357 122.42 56.4705 120.571L24.0195 51.4974C23.1543 49.6484 23.9182 47.4987 25.759 46.6304L63.5378 28.7698L89.3689 39.3327Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M63.5508 28.7227L70.4826 43.5322C71.4885 45.5694 74.0737 46.4696 76.0976 45.4625L89.3792 39.3164",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    filter: "url(#filter1_d_11509_163846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.218 44.6879L136.05 103.991C136.05 106.032 134.446 107.646 132.41 107.641L74.6168 107.599C72.5806 107.593 70.9664 105.981 70.9662 103.94L70.8451 27.6389C70.845 25.5978 72.4485 23.9842 74.4847 23.9898L116.289 24.0671L135.218 44.6879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M116.324 24.0195L116.312 40.3529C116.357 42.6221 118.317 44.5405 120.579 44.4972L135.223 44.6308",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    filter: "url(#filter2_d_11509_163846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.571 71.0177L147.485 125.175C146.684 127.002 144.436 127.799 142.636 126.889L90.219 102.599C88.3929 101.79 87.5901 99.5347 88.3916 97.7076L120.177 28.5254C120.978 26.6983 123.226 25.9013 125.025 26.8109L163.088 44.4803L171.571 71.0177Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M162.986 44.3777L156.189 59.2233C155.207 61.3259 156.257 63.8619 158.356 64.8508L171.552 70.9444",
    fill: "#E6E6E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11509_163846",
    x: -0.335938,
    y: 12.77,
    width: 139.949,
    height: 141.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11509_163846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11509_163846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11509_163846",
    x: 46.8457,
    y: 7.98975,
    width: 113.205,
    height: 131.651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11509_163846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11509_163846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11509_163846",
    x: 64.082,
    y: 10.4336,
    width: 131.488,
    height: 148.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11509_163846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11509_163846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11509_163846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-data.d0a9f32c.svg";
export { ForwardRef as ReactComponent };